import * as TypesSale from '../types/types_sale'
import Vue from 'vue';

export default {
    state: {
        orderInfo: {
            data: {
                paymentId: '',
                contact: {
                    telephone: '',
                    wechat: ''
                }
            },
            params: {
                phone: '',
                name: '',
                grade: '',
                class: '',
                schoolName: '',
            }
        }
    },
    mutations: {
        [TypesSale.SET_SALE_WARONG_COPIES](state, payload) {
            state.orderInfo = payload || {}
        }
    },
    actions: {
        [TypesSale.SALE_WARONG_COPIES](ctx, params) {
            return Vue.http.post('/v1/payments/cuoti-member', params).then(function (resp) {
                return Vue.checkResp(resp)
            }).then(data => {
                ctx.commit(TypesSale.SET_SALE_WARONG_COPIES, { data, params })
                return data
            }).catch(err => {
                // 统一错误处理
                ctx.commit(TypesSale.SET_SALE_WARONG_COPIES, {
                    data: {
                        paymentId: '',
                        contact: {
                            telephone: '',
                            wechat: ''
                        }
                    },
                    params: {
                        phone: '',
                        name: '',
                        grade: '',
                        class: '',
                        schoolName: '',
                    }
                })
                throw err
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_sale.js